export default {
  type: "Art des Dokumentes",
};
